import InputService from "../input/inputservice";
import Stage from "../stage/stage";
import DioramaCamera from "./diorama_camera";

export default class DioramaCameraControl {
  input: InputService;
  camera: DioramaCamera;

  pan_min_x: number = -5.0;
  pan_max_x: number =  5.0;

  drag_sensitivity_mouse: number = 0.008;
  drag_sensitivity_touch: number = 0.010;

  smoothing: number = 0.25;

  private target_x: number;
  private dragging: boolean = false;
  private last_drag_x: number = 0;
  private enabled: boolean = true;

  constructor(camera: DioramaCamera) {
    this.camera = camera;
    this.input = Stage.instance().input_service;
    this.target_x = camera.target[0];
  }

  set_enabled(enabled: boolean): void
  {
     if (this.enabled === enabled) return;
    this.enabled = enabled;
    this.dragging = false;
  }

   is_enabled(): boolean {
    return this.enabled;
  }

  set_pan_bounds(min_x: number, max_x: number): void {
    this.pan_min_x = min_x;
    this.pan_max_x = max_x;
    this.target_x = this.clamp_x(this.target_x);
  }

  set_sensitivity(mouse: number, touch: number): void {
    this.drag_sensitivity_mouse = mouse;
    this.drag_sensitivity_touch = touch;
  }

  set_smoothing(amount: number): void {
    this.smoothing = Math.max(0.0, Math.min(1.0, amount));
  }

  snap_to(x: number): void {
    this.target_x = this.clamp_x(x);
    this.camera.target[0] = this.target_x;
    this.camera.set_target(
      this.camera.target[0],
      this.camera.target[1],
      this.camera.target[2]
    );
  }
    tick(_delta_time: number): void 
    {
    if (!this.enabled) return;
    const pointer = this.input.current.pointer;
    const pinch = this.input.current.pinch;

    const right_down = this.input.current.buttons.secondary.down;
    const right_pressed = this.input.current.buttons.secondary.pressed;
    const right_released = this.input.current.buttons.secondary.released;

    const two_finger_drag =
      pointer.kind === "touch" && pinch.active;

    const drag_active = right_down || two_finger_drag;

    if (!this.dragging && drag_active) {
      this.dragging = true;
      this.last_drag_x = two_finger_drag
        ? pinch.midpoint_x
        : pointer.x;
    } else if (this.dragging && !drag_active) {
      this.dragging = false;
    }

    if (this.dragging) {
      let current_x: number;
      let sensitivity: number;

      if (two_finger_drag) {
        current_x = pinch.midpoint_x;
        sensitivity = this.drag_sensitivity_touch;
      } else {
        current_x = pointer.x;
        sensitivity = this.drag_sensitivity_mouse;
      }

      const delta = current_x - this.last_drag_x;
      this.last_drag_x = current_x;

      this.target_x = this.clamp_x(this.target_x - delta * sensitivity);
    }

    const current = this.camera.target[0];
    const next = current + (this.target_x - current) * this.smoothing;

    if (Math.abs(next - current) > 0.00001) {
      this.camera.set_target(
        next,
        this.camera.target[1],
        this.camera.target[2]
      );
    }

    if (right_pressed || right_released) {
      this.last_drag_x = two_finger_drag
        ? pinch.midpoint_x
        : pointer.x;
    }
  }
    private clamp_x(x: number): number {
    if (x < this.pan_min_x) return this.pan_min_x;
    if (x > this.pan_max_x) return this.pan_max_x;
    return x;
  }
}